import type { IconComponentBaseProps } from 'components/atoms/Icon/types';

import { defaultTheme } from '@/theme';

type CalendarTodayProps = IconComponentBaseProps;

export const CalendarToday = ({
  className,
  width = 24,
  height = 24,
  fill = defaultTheme.mantineColors.gray[7],
}: CalendarTodayProps) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <mask
        id="mask0_8417_690"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_8417_690)">
        <path
          d="M5.30775 21.5C4.80258 21.5 4.375 21.325 4.025 20.975C3.675 20.625 3.5 20.1974 3.5 19.6922V6.30773C3.5 5.80257 3.675 5.37498 4.025 5.02498C4.375 4.67498 4.80258 4.49998 5.30775 4.49998H6.69225V3.15374C6.69225 2.93457 6.76567 2.75157 6.9125 2.60473C7.05933 2.45807 7.24233 2.38474 7.4615 2.38474C7.68083 2.38474 7.86383 2.45807 8.0105 2.60473C8.15733 2.75157 8.23075 2.93457 8.23075 3.15374V4.49998H15.8077V3.13474C15.8077 2.9219 15.8795 2.74365 16.023 2.59998C16.1667 2.45648 16.3449 2.38474 16.5577 2.38474C16.7706 2.38474 16.9487 2.45648 17.0922 2.59998C17.2359 2.74365 17.3077 2.9219 17.3077 3.13474V4.49998H18.6923C19.1974 4.49998 19.625 4.67498 19.975 5.02498C20.325 5.37498 20.5 5.80257 20.5 6.30773V19.6922C20.5 20.1974 20.325 20.625 19.975 20.975C19.625 21.325 19.1974 21.5 18.6923 21.5H5.30775ZM5.30775 20H18.6923C18.7692 20 18.8398 19.9679 18.9038 19.9037C18.9679 19.8397 19 19.7692 19 19.6922V10.3077H5V19.6922C5 19.7692 5.03208 19.8397 5.09625 19.9037C5.16025 19.9679 5.23075 20 5.30775 20ZM5 8.80773H19V6.30773C19 6.23073 18.9679 6.16023 18.9038 6.09623C18.8398 6.03207 18.7692 5.99998 18.6923 5.99998H5.30775C5.23075 5.99998 5.16025 6.03207 5.09625 6.09623C5.03208 6.16023 5 6.23073 5 6.30773V8.80773Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
